module.exports = __webpack_public_path__ + "img/26.80916443.svg";